var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tags"},_vm._l((_vm.items),function(tag){return _c('Tag',{key:tag.id,attrs:{"item":tag,"color":_vm.getColor(tag),"selected":_vm.isTagSelected(tag),"use-checkmark":_vm.useCheckmark},on:{"select-tag":_vm.selectTag}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }